
import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";
import { IPricing } from "@/app/domain";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { ReactiveComponent } from "../../entities/base-component";
import { DeliveryCombinedType } from "@/app/constants";
export class SubtotalEstimateReviewCalculationStrategy extends CalculationStrategy {
    calculate(component: ReactiveComponent, [estimatePrice, installationPrice, deliveryPrice, deliveryType, isIncludeCombinedDeliveryInPrice, noDiscountExtraTotal]): PriceResult {
        if (!deliveryPrice || !installationPrice || !estimatePrice) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculateTotalDue(
                estimatePrice, installationPrice, deliveryPrice, deliveryType, isIncludeCombinedDeliveryInPrice, noDiscountExtraTotal,
                CostDealType,
            ),
            priceB2C: this.calculateTotalDue(
                estimatePrice, installationPrice, deliveryPrice, deliveryType, isIncludeCombinedDeliveryInPrice, noDiscountExtraTotal,
                B2CDealType,
            ),
            priceB2B: this.calculateTotalDue(
                estimatePrice, installationPrice, deliveryPrice, deliveryType, isIncludeCombinedDeliveryInPrice, noDiscountExtraTotal,
                B2BDealType,
            ),
        };
    }

    private calculateTotalDue(
        estimatePrice: IPricing,
        installationPrice: IPricing,
        deliveryPrice: IPricing,
        deliveryType: string,
        isIncludeCombinedDeliveryInPrice: boolean,
        noDiscountExtraTotal: IPricing,
        dealType: string,
    ) {
        const estimatePriceValue = estimatePrice.getSystemPrice(dealType).getValue();
        const noDiscountExtraTotalValue = noDiscountExtraTotal.getSystemPrice(dealType).getValue() || 0;
        const installationSum = installationPrice.getSystemPrice(dealType).getValue();

        const deliveryPriceValue = deliveryPrice.getSystemPrice(dealType).getValue();
        if (deliveryType === DeliveryCombinedType && isIncludeCombinedDeliveryInPrice) {
            return estimatePriceValue + noDiscountExtraTotalValue + installationSum;
        }
        console.log({
            es: estimatePriceValue,
            extra: noDiscountExtraTotalValue,
            in: installationSum,
            del: deliveryPriceValue
        })
        return estimatePriceValue + noDiscountExtraTotalValue + installationSum + deliveryPriceValue;
    }
}
